/**
 * Checks whether the specified variable is a string.
 *
 * @param variable
 * @returns {boolean}
 */
export const isString = (variable) => {
    return typeof variable === 'string' || variable instanceof String
}

/**
 * Converts specific HTML entities to their corresponding characters.
 *
 * @param {string} string
 * @returns {string}
 */
export function unescapeHtml(string) {
    const htmlEntities = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&apos;": "'",
        "&acute;": "´",
    };

    Object.keys(htmlEntities).forEach((htmlEntity) => {
        string = replaceAll(string, htmlEntity, htmlEntities[htmlEntity]);
    })

    return string;
}

export function replaceAll(str, find, replace) {
    if (find && Array.isArray(find)) {
        find.forEach((findItem, findItemIndex) => {
            str = replaceAll(str, findItem, Array.isArray(replace) ? replace[findItemIndex] : replace)
        })

        return str;
    }

    // The characters we need to escape for a replacement
    const escapeChars = ['.', '?', '(', ')'];
    find = escapeChars.includes(find) ? `\\${find}` : find;

    return str.replace(new RegExp(find, 'g'), replace);
}

/**
 * Ensures that the specified string does not end with the specified character.
 *
 * @param {string} str
 * @param {string} char
 * @returns {string}
 */
export function trimEnd(str, char) {
    return str && str.endsWith(char) ? str.slice(0, -1) : str;
}

export function toSnakeCase(str) {
    return str &&
        str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
            .map(x => x.toLowerCase())
            .join('_');
}